import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const getFarmVisitReport = createAsyncThunk(
  "app/getFarmVisitReport",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(
      `/api/report/farm-visit/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);
